module.exports = __webpack_public_path__ + "img/logo-fri_reg_old.d681565f.svg";